// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1z8Ki","field":"styles_field__1pXrx","fieldCol":"styles_fieldCol__1gsv6","diffCol":"styles_diffCol__1hPuo","diff":"styles_diff__PncIZ"};